const constants = require('../config/constants');

export const viewFile = (filename) => {
  let urlRegxp = constants.urlRegxp;
  let emptyRegxp = constants.emptyRegxp;
  if(urlRegxp.test(filename) || emptyRegxp.test(filename) || filename === null) {
    viewLinkInNewWindow(filename);
  }
  else {
    let url= constants.s3.fileLink + `${filename}`;
    if(filename.endsWith("pdf")){
      window.open(`/view/pdfFile?${encodeURIComponent(url)}`,'popup','width=600,height=600,scrollbars=no,resizable=no')
    }
    else{
      window.open(`/view/pngFile?${encodeURIComponent(url)}`,'popup','width=600,height=600,scrollbars=no,resizable=no')
    }
  }
}

export const viewLinkInNewWindow = (link) => {
  let urlRegxp = constants.urlRegxp;
  if(urlRegxp.test(link)) {
    window.open(link,'popup','width=600,height=600,scrollbars=no,resizable=no')
  }
  else {
    let newWindow = window.open("",'popup','width=600,height=600,scrollbars=no,resizable=no');
    newWindow.document.write("<p> No File Found </p>");
  }
}

export const viewBlobFile = (file) => {
    let url=URL.createObjectURL(file);
    // console.log(file.type, file)
    if(file.type === "application/pdf"){
      window.open(`/view/pdfFile?${encodeURIComponent(url)}`,'popup','width=600,height=600,scrollbars=no,resizable=no')
    }
    else{
      window.open(`/view/pngFile?${encodeURIComponent(url)}`,'popup','width=600,height=600,scrollbars=no,resizable=no')
    }
}


// WEBPACK FOOTER //
// ./src/components/viewFileUtilFunction.js